import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/shared/components/ui/tabs';
import { MembersTab } from './MembersTab';
import { TeamBalancesPanel } from './TeamBalancesPanel';

/**
 * "Equipo" tab content on `TimeOffPage` — Owner/Admin only. Uses the default
 * shadcn pill `Tabs` (not the underline style used by the page-level tabs),
 * centered, matching the "Saldos"/"Miembros" segmented toggle in the design.
 */
export function TeamSection() {
  const { t } = useTranslation('timeOff');

  return (
    <Tabs defaultValue="members" data-testid="time-off-team-sub-tabs">
      <div className="flex justify-center">
        <TabsList>
          <TabsTrigger value="balances">{t('team.tabs.balances')}</TabsTrigger>
          <TabsTrigger value="members">{t('team.tabs.members')}</TabsTrigger>
        </TabsList>
      </div>
      <TabsContent value="members">
        <MembersTab />
      </TabsContent>
      <TabsContent value="balances">
        <TeamBalancesPanel />
      </TabsContent>
    </Tabs>
  );
}
